(() => {
  const init = () => {
    document.querySelectorAll('[data-faq-item]').forEach((item) => {
      const btn = item.querySelector('[data-faq-toggle]');
      const content = item.querySelector('[data-faq-content]');
      const chevron = item.querySelector('[data-faq-chevron]');
      if (!btn || !content) return;

      btn.addEventListener('click', () => {
        const isOpen = content.classList.contains('opacity-100');

        // Close all others (single-open accordion)
        document.querySelectorAll('[data-faq-content].opacity-100').forEach((other) => {
          if (other === content) return;
          other.classList.remove('max-h-96', 'opacity-100');
          other.classList.add('max-h-0', 'opacity-0');
          const sibling = other.closest('[data-faq-item]')?.querySelector('[data-faq-toggle]');
          const siblingChev = other.closest('[data-faq-item]')?.querySelector('[data-faq-chevron]');
          sibling?.setAttribute('aria-expanded', 'false');
          siblingChev?.classList.remove('rotate-180');
        });

        if (isOpen) {
          content.classList.remove('max-h-96', 'opacity-100');
          content.classList.add('max-h-0', 'opacity-0');
          btn.setAttribute('aria-expanded', 'false');
          chevron?.classList.remove('rotate-180');
        } else {
          content.classList.remove('max-h-0', 'opacity-0');
          content.classList.add('max-h-96', 'opacity-100');
          btn.setAttribute('aria-expanded', 'true');
          chevron?.classList.add('rotate-180');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
